<template>
<div class="chapter">
<div class="inner_page">
<p class="htit1"><a id="page_1"></a><span class="bold">SOG</span></p>
<p class="htit2"><span class="bold">A PHOTO HISTORY OF</span></p>
<p class="htit2"><span class="bold">THE SECRET WARS</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?6ae69b08